import { useEffect } from "react"



export const useOnClickOutside = (elementRef, callBack, enabled = true) => {
  
  
  useEffect(() => {
    if (!enabled) return;
    const handleOutsideClick = (event) => {
      const path = event.path || (event.composedPath && event.composedPath());
      if (elementRef.current && !path.includes(elementRef.current)) {
        callBack()
      }
    };
    document.addEventListener('click', handleOutsideClick)
  
    return () => {
      document.removeEventListener('click', handleOutsideClick)
    }
  }, [callBack])
  
}